<div class="menu-label"
     [style.background-color]="'var(--ion-color-' + menuLabel.color +')'"
     [style.color]="'var(--ion-color-' + menuLabel.color +'-contrast)'">
    {{ menuLabel.name }}
</div>
